export default {"src":"/_next/static/media/shape.e4c5fc05.svg","height":450,"width":457,"blurWidth":0,"blurHeight":0};